const ESTIMATED_CHALLENGE_TOTAL_VIEWS = 2500;
const ESTIMATED_EFFECTIVE_VIEWS_RATIO = 0.8;
const ESTIMATED_CHALLENGE_EFFECTIVE_VIEWS =
  ESTIMATED_CHALLENGE_TOTAL_VIEWS * ESTIMATED_EFFECTIVE_VIEWS_RATIO;
const REWARDS_TO_BUDGET_CONVERSION_RATE = 0.6


export default function estimateChallengeResults(
  budget,
  reward,
) {
  const rewardsBudget = budget * REWARDS_TO_BUDGET_CONVERSION_RATE;

  const estimatedRewardPerParticipant =
    reward.fixed + reward.variable * (ESTIMATED_CHALLENGE_EFFECTIVE_VIEWS / 1000);

  const estimatedParticipants = Math.floor(rewardsBudget / estimatedRewardPerParticipant);
  const views = Math.floor(estimatedParticipants * ESTIMATED_CHALLENGE_TOTAL_VIEWS);

  return {
    participants: estimatedParticipants,
    views,
  };
}
